// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:600px){.contactAExpertText[data-v-cf7ac6f0]{font-size:1.2rem!important}}", ""]);
// Exports
module.exports = exports;
